<script>
import { mapActions } from 'vuex';
import PageProps from 'components/mixins/page-props';

import NuttremaOverlayHelpButton from 'components/ui/overlay/nuttrema-overlay-help-button';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import MyPreferencesStandardHeader from 'components/pages/professional/settings/my-preferences/shared/cmpt-my-preferences-standard-header';

import FormPersonalProfilePicture from './form-personal-profile-picture';

export default {
  name: 'page-personal-profile-picture',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaLayoutContent,
    NuttremaOverlayHelpButton,
    MyPreferencesStandardHeader,
    FormPersonalProfilePicture,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
  methods: {
    ...mapActions([
      'SavePersonalProfilePicture',
      'RemovePersonalProfilePicture',
    ]),
    uploadProfilePicture(file) {
      return this.SavePersonalProfilePicture({ file })
        .then(() => {
          this.successNotification({ label: 'label.profile_picture' });
        }).catch(() => {
          this.errorNotification({ label: 'label.profile_picture' });
        });
    },
    removeProfilePicture() {
      return this.RemovePersonalProfilePicture()
        .then(() => {
          this.successNotification({ message: 'message.success_profile_picture_remove' });
        }).catch(() => {
          this.errorNotification({ message: 'message.error_profile_picture_remove' });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/profile-picture/page-personal-profile-picture.vue